import Alpine from "alpinejs";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";

window.servicesSlider = (id) => ({
  swiper: null,
  active: 0,

  init() {
    const el = document.getElementById(id);
    if (!el) return;

    const hasLoop = el.querySelectorAll(".swiper-slide").length > 1;

    this.swiper = new Swiper(el, {
      modules: [Navigation],
      speed: 650,
      loop: hasLoop,
      autoHeight: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: `.js-next-${id}`,
        prevEl: `.js-prev-${id}`,
      },
      on: {
        // use the 'swiper' argument instead of this.swiper
        init: (swiper) => {
          this.active = swiper?.realIndex ?? 0;
        },
        slideChange: (swiper) => {
          this.active = swiper?.realIndex ?? 0;
        },
      },
    });
  },

  go(i) {
    if (!this.swiper) return;
    // slideToLoop keeps the index correct when loop is enabled
    if (typeof this.swiper.slideToLoop === "function")
      this.swiper.slideToLoop(i);
    else this.swiper.slideTo(i);
  },

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  },
});

// If using Alpine.js
document.addEventListener("alpine:init", () => {
  Alpine.data("servicesSlider", window.servicesSlider);
});

function toggleActiveClasses(container, activeIndex) {
  const cards = container.querySelectorAll(`[class*="js-card-"]`);
  cards.forEach((card, i) => {
    card.classList.remove("bg-[#0E2C20]", "text-white");
    card.classList.add("bg-white", "text-[#1E3028]");
    if (i === activeIndex) {
      card.classList.remove("bg-white", "text-[#1E3028]");
      card.classList.add("bg-[#0E2C20]", "text-white");
    }
  });
}

window.testimonialSlider = (id) => ({
  swiper: null,
  init() {
    const el = document.getElementById(id);
    if (!el) return;

    const loop = el.querySelectorAll(".swiper-slide").length > 1;

    this.swiper = new Swiper(el, {
      modules: [Navigation, Pagination],
      loop,
      speed: 600,
      spaceBetween: 24,
      slidesPerView: 1.05,
      breakpoints: {
        768: { slidesPerView: 1.5 },
        1024: { slidesPerView: 2 },
        1440: { slidesPerView: 2.5 },
      },
      navigation: {
        nextEl: `.js-next-${id}`,
        prevEl: `.js-prev-${id}`,
      },
      pagination: {
        el: `.js-pagination-${id}`,
        clickable: true,
        bulletClass: "swiper-bullet",
        bulletActiveClass: "swiper-bullet-active",
        renderBullet: (index, className) =>
          `<span class="${className} inline-block w-2 h-2 rounded-full bg-black/20 mx-1"></span>`,
      },
      on: {
        init: (swiper) => {
          toggleActiveClasses(el, swiper.realIndex ?? 0);
        },
        slideChange: (swiper) => {
          toggleActiveClasses(el, swiper.realIndex ?? 0);
        },
      },
    });
  },
});

window.teamGrid = () => ({
  selected: "all",
  perPage: 12,
  step: 4,
  visible: 12,
  moreAvailable: false,
  modal: false,
  person: null,

  init() {
    this.visible = this.perPage;
    this.update();
  },
  openModal() {
    this.modal = true;
    document.body.classList.add("overflow-hidden");
    // optional: move focus into modal for a11y
    requestAnimationFrame(() => {
      const closeBtn = document.querySelector('[aria-label="Close"]');
      closeBtn && closeBtn.focus();
    });
  },

  closeModal() {
    this.modal = false;
    document.body.classList.remove("overflow-hidden");
  },
  select(slug) {
    this.selected = slug;
    this.visible = this.perPage;
    this.update();
    // optional scroll into view of cards:
    // this.$refs.list.scrollIntoView({ behavior: 'smooth', block: 'start' });
  },

  filterMatches(card) {
    const cats = (card.dataset.cats || "").split("|").filter(Boolean);
    return this.selected === "all" || cats.includes(this.selected);
  },

  update() {
    const cards = Array.from(this.$refs.list.querySelectorAll(".team-card"));
    let shown = 0;
    let totalMatches = 0;

    cards.forEach((card) => {
      const match = this.filterMatches(card);
      if (match) {
        totalMatches++;
        if (shown < this.visible) {
          card.classList.remove("hidden");
          shown++;
        } else {
          card.classList.add("hidden");
        }
      } else {
        card.classList.add("hidden");
      }
    });

    this.moreAvailable = shown < totalMatches;
  },

  loadMore() {
    this.visible += this.step;
    this.update();
  },
});
// Components
window.navDrop = () => ({
  openMenu: null,
  _timer: null,
  open(i) {
    this.cancelClose();
    this.openMenu = i;
  },
  scheduleClose(delay = 180) {
    this.cancelClose();
    this._timer = setTimeout(() => {
      this.openMenu = null;
    }, delay);
  },
  cancelClose() {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  },
});

document.addEventListener("DOMContentLoaded", function () {
  const noRadio = document.getElementById("liveInJerseyNo");
  const modal = document.getElementById("jerseyModal");
  const closeBtn = document.getElementById("jerseyModalClose");

  if (!noRadio || !modal || !closeBtn) return;

  function openModal() {
    modal.classList.remove("hidden");
    modal.classList.add("flex");
    document.body.classList.add("overflow-hidden");
    modal.setAttribute("aria-hidden", "false");
  }

  function closeModal() {
    modal.classList.add("hidden");
    modal.classList.remove("flex");
    document.body.classList.remove("overflow-hidden");
    modal.setAttribute("aria-hidden", "true");
  }

  // Show modal when "No" selected
  noRadio.addEventListener("change", function () {
    if (this.checked) {
      openModal();
    }
  });

  // Close button
  closeBtn.addEventListener("click", closeModal);

  // Click outside the modal content to close
  modal.addEventListener("click", function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });

  // ESC key to close
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && !modal.classList.contains("hidden")) {
      closeModal();
    }
  });
});
// Global
window.Alpine = Alpine;

// Inits
Alpine.start();
